import { clsx } from "clsx"
import { PropsWithChildren } from "react"
import { FormattedMessage } from "react-intl"
import { Link } from "react-router-dom"
import { HelpNote } from "../common/HelpNote"
interface Props {
  title: string
  href?: string
  active?: number
}

export const VerificationStep = ({ title, href, active, children }: PropsWithChildren<Props>) => {
  return (
    <li className={clsx("welcome-info__controls-list", { active: active !== 0 })}>
      <div className="dropright tooltips-ver">
        <FormattedMessage id={title} />
        {children != null && <HelpNote>{children}</HelpNote>}
      </div>
      {href != null && (
        <Link to={href} className="welcome-info__button-link">
          <FormattedMessage id="edit" />
        </Link>
      )}
    </li>
  )
}
